import { Link } from "react-router-dom";
import { DOCS } from "@/data/legal";

export function Footer() {
  return (
    <footer className="border-t border-border mt-20" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="font-mono-data text-[11px] text-muted-foreground text-center sm:text-left">
          © {new Date().getFullYear()} Vaelith Intelligence, LLC · Berkley, Massachusetts
        </div>
        <nav className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2">
          {DOCS.map((d) => (
            <Link key={d.slug} to={`/legal/${d.slug}`} data-testid={`footer-link-${d.slug}`}
              className="font-mono-data text-[11px] uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">
              {d.short}
            </Link>
          ))}
          <a href="mailto:vaelithsupport@gmail.com"
            className="font-mono-data text-[11px] uppercase tracking-wider text-muted-foreground hover:text-foreground transition-colors">Contact</a>
        </nav>
      </div>
    </footer>
  );
}
